import React, { useEffect, useState } from 'react';
import './App.css';
import { RenderRoutes } from './services/Routes';
import Routes from './services/Routes';
import { Suspense } from 'react';
import ReactGA from 'react-ga4';
import { useHistory, useLocation } from "react-router";

function App() {
    const history = useHistory();
    const location = useLocation();
    const [authCheckCompleted, setAuthCheckCompleted] = useState(false);

    useEffect(() => {
        let isLoggedIn = localStorage.getItem('isLoggedIn');
        let isUserLoggedOut = !isLoggedIn || isLoggedIn !== '1' || isLoggedIn === null;
        if (isUserLoggedOut === null) {
            isUserLoggedOut = true;
        }

        const performAuthCheck = () => {
            // Check if the location is /registerpage2/{id}/{token}
            const isRegisterPage = location.pathname.includes('/registerpage2/');
            const isChangePasswordPage = location.pathname.includes('/changepassword/');

            // Prevent redirect if the user is on /login, /forgotpassword, /contactus or /registerpage2/{id}/{token}
            if (isUserLoggedOut && !['/login', '/forgotpassword', '/contactus'].includes(window.location.pathname) && !isRegisterPage && !isChangePasswordPage) {
                console.log('Redirecting to login...');
                // history.replace("/login");
            } else {
                console.log('Auth check completed');
                setAuthCheckCompleted(true);
            }
        };

        performAuthCheck();

        const unblock = history.block((location) => {
            const logoutInitiated = localStorage.getItem('logoutInitiated');
            let isLoggedIn = localStorage.getItem('isLoggedIn');
            let isUserLoggedOut = !isLoggedIn || isLoggedIn !== '1' || isLoggedIn === null;
            if (isUserLoggedOut === null) {
                isUserLoggedOut = true;
            }
            if (logoutInitiated === 'true' || isUserLoggedOut) {
                localStorage.removeItem('logoutInitiated');
                return true;
            }
            if (['/login', '/'].includes(location.pathname) && window.location.pathname !== '/forgotpassword') {
                return window.confirm('Do you want to leave this page? You will be logged out.');
            }
            return true;
        });

        return () => unblock();  // Cleanup unblock on unmount
    }, [history, location.pathname]);

    ReactGA.initialize('G-MZ66L3BWJX');

    if (!authCheckCompleted) {
        return null;
    }

    return (
        <div className="App">
            <RenderRoutes routes={Routes} />
        </div>
    );
}

export default function WrappedApp() {
    ReactGA.initialize('G-MZ66L3BWJX');

    return (
        <Suspense fallback="...is loading">
            <App />
        </Suspense>
    );
}
